var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLhoist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 227.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #27abe2;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #221e1f;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "58.3 139.9 119.5 139.9 138 116.3 138 156.7 138.1 156.8 124.5 173.5 58.3 173.5 58.3 139.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "95.6 117 137.9 64.4 137.9 104.8 138 104.9 128.4 117 95.6 117"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m231.8.2l-46,57.7.1.2c13.5,19.3,22.6,40,22.6,65,0,57.6-46.7,104.3-104.3,104.3-57.5,0-104.2-46.7-104.2-104.3S45.2,18.4,102.8,18.4L118.1.2h41.4l-42.3,52.8-.3-.1c-4.3-.8-8.7-1.2-13.2-1.2-39.6,0-71.7,32.1-71.7,71.7s32.1,71.7,71.7,71.7,71.7-32.1,71.7-71.7c0-26.3-14.1-49.3-35.2-61.8h.2L189.8.2h42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "236.6 0 263 0 263 80.3 293.7 80.3 293.7 103.6 236.6 103.6 236.6 0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m299.1,0h23.2v33h.3c3.9-7,11.8-9.8,20-9.8,7.4,0,16.2,2.7,21.1,8.5,6.6,7.7,7.3,14.6,7.3,28.4v43.4h-23.2v-42.3c0-3.8,0-16.2-12.5-16.2s-13,11.6-13,15.4v43.1h-23.2V0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m417.1,84.2c10.1,0,18.6-8.3,18.6-19.6s-8.5-19.6-18.6-19.6-18.6,8.3-18.6,19.6,8.5,19.6,18.6,19.6m0-60.9c28.3,0,41.9,22.3,41.9,41.3s-13.6,41.3-41.9,41.3-41.9-22.3-41.9-41.3,13.6-41.3,41.9-41.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m485.7,17.6h-23.2V0h23.2v17.6Zm0,86h-23.2V25.9h23.2v77.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m528.1,47.7c-.1-1.7-.4-5.9-7.3-5.9-4.9,0-6.6,3.1-6.6,5.2,0,4.2,5.7,6.6,11.9,8.4,13.2,3.6,27.2,7.6,27.2,24.4s-14.4,26.5-31.6,26.5c-11.8,0-29.5-5.3-31.6-25.8h23.1c1,7.1,7.8,7.1,8.8,7.1,3.9,0,8.1-2.2,8.1-6,0-6-5.7-6.7-20.6-12.5-10.1-3.2-18.5-9.8-18.5-20.3,0-15.4,14-25.6,30.1-25.6,10.2,0,27.9,4.1,29.8,24.5h-22.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "588.8 25.9 600 25.9 600 43.5 588.8 43.5 588.8 103.6 565.6 103.6 565.6 43.5 554.1 43.5 554.1 25.9 565.6 25.9 565.6 0 588.8 0 588.8 25.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLhoist);
export default __webpack_public_path__ + "static/media/logo-lhoist.bf0c893c342dcc5ad47269624e96258a.svg";
export { ForwardRef as ReactComponent };